import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({

    grid: {
        margin: "5%",
    },

    gridContainer: {
        alignContent: "flex-start",
        direction: "column",
    },

    title: {
        fontSize: "3.8em",
        color: "#000",
        fontWeight: "700",
        fontFamily: "Inter",
        marginLeft:"15%",
        marginRight:"15%",
        marginBottom:'10%',
        lineHeight: 1.3

    },
    image: {
        width: "80%",
        margin: "5%",
        marginTop: "10%",
      },
    subTitle: {
        fontSize: "1em",
        lineHeight: 1.3,
        color: "#000",
        fontWeight: "400",
        fontFamily: "Inter",
        marginLeft:"15%",
        marginBottom:'5%',

    },
    text:{
        fontSize: "1em",
        color: "#000",
        
        fontWeight: "400",
        fontFamily: "Inter", 
    },
    textBold:{
        fontSize: "1em",
        color: "#000",
        fontWeight: "800",
        fontFamily: "Inter", 
    },
    protocol:{
        fontSize: "1.7em",
        color: "#000",
        fontWeight: "400",
        fontFamily: "Inter",
        marginLeft:"15%",
        marginBottom:'10%',
        
    },
    button:{
        marginLeft:"12%",
        marginBottom:'12%',
       
    },
    link:{
        textDecoration:"none",
    },
    inputProtocol:{
        marginLeft:"15%",
        marginBottom:'10%',
    },
    table:{
        width:'60%',
        marginLeft:"15%",
        marginBottom:'10%',
        overflowX: 'hidden'
    },

    badgeWarning:{
        display: 'inline-block',
        padding: '0.35em 0.7em 0.35em 0.7em',
        fontSize: '90%',
        fontWeight: 700,
        fontFamily: "Inter",
        lineHeight: 1,
        color: '#000',
        backgroundColor:'#ffc107',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'baseline',
        borderRadius: '0.575rem'

    },
    badgeSuccess:{
        display: 'inline-block',
        padding: '0.35em 0.7em 0.35em 0.7em',
        fontSize: '90%',
        fontWeight: 700,
        fontFamily: "Inter",
        lineHeight: 1,
        color: '#fff',
        backgroundColor:'#009900',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'baseline',
        borderRadius: '0.575rem'
    
        },
    badgeCancel:{
        display: 'inline-block',
        padding: '0.35em 0.7em 0.35em 0.7em',
        fontSize: '90%',
        fontWeight: 700,
        fontFamily: "Inter",
        lineHeight: 1,
        color: '#fff',
        backgroundColor:'#9a0000',
                textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'baseline',
        borderRadius: '0.575rem'



    },
  
}));

export { useStyles };
